import {CommonResponse, BaseRequestParams, GetSingleParamsType, instance} from "./API"
import {AxiosResponse} from "axios"
import {filterToString} from "../helps/filterToString"
import {ObjectGroupScheduleResponse, ObjectGroupSchedulesResponse} from "../models/response"

export const objectGroupScheduleApi = {
    getSchedules(params?: GetObjectGroupSchedules): Promise<CommonResponse<ObjectGroupSchedulesResponse>> {
        const paramsString = filterToString(params)
        return instance.get(`ObjectGroupSchedule${paramsString}`, {signal: params?.controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    getSchedule(params: GetSingleParamsType): Promise<CommonResponse<ObjectGroupScheduleResponse>> {
        const {id, controller} = params
        return instance.get(`ObjectGroupSchedule/${id}`, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    createSchedule(form: CreateObjectGroupSchedule): Promise<CommonResponse<ObjectGroupScheduleResponse>> {
        const {controller, ...rest} = form
        return instance.post(`ObjectGroupSchedule`, {...rest}, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    changeSchedule(form: ChangeObjectGroupSchedule): Promise<CommonResponse<ObjectGroupScheduleResponse>> {
        const {id, controller, ...rest} = form
        return instance.put(`ObjectGroupSchedule/${id}`, {...rest}, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    deleteSchedule(id: number): Promise<CommonResponse<any>> {
        return instance.delete(`ObjectGroupSchedule/${id}`).then((res: AxiosResponse) => res.data)
    },
}

export type GetObjectGroupSchedules = {
    idGroup?: number
} & BaseRequestParams

export type CreateObjectGroupSchedule = {
    idGroup: number
    security: boolean
    comment: string
    days: Array<number>
    hour: number
    minute: number
} & BaseRequestParams

export type ChangeObjectGroupSchedule = {
    id: number
} & CreateObjectGroupSchedule